import React from 'react';
import { useAllItemTypesQuery } from '../graphql/queries/allItemTypes.generated';
import { LayoutStoreInstance } from '../LayoutStore';
import i18n from '@/utils/i18n';
import { Input } from 'reactstrap';
import { ItemTypeCategory } from '@/utils/ItemTypes';

export function ItemTypeSelector(props: {
  category: ItemTypeCategory;
  itemTypeId: string;
  setItemTypeId: (id: string) => void;
  disabled?: boolean;
  className?: string;
}) {
  const { category, itemTypeId, setItemTypeId, disabled, className } = props;
  const { data: itemTypes, loading: loadingItemTypes } = useAllItemTypesQuery({
    variables: {
      filter: {
        category,
        archived: false,
      },
      skip: 0,
      take: 100,
    },
    onError: (error) => {
      console.log(error);
      LayoutStoreInstance.setError(
        i18n.t('ItemTypeSelector:errorLoadingItemTypes') + error.message,
      );
    },
  });

  if (
    itemTypes != null &&
    itemTypes.itemTypes.total > itemTypes.itemTypes.items.length
  ) {
    console.log(
      'ItemTypeSelector: Too many item types, only showing first 100',
    );
    LayoutStoreInstance.setError(
      i18n.t('ItemTypeSelector:errorTooManyItemTypes'),
    );
  }

  return (
    <Input
      type="select"
      className={className}
      readOnly={disabled === true}
      title={i18n.t('Common:type')}
      disabled={loadingItemTypes}
      value={itemTypeId}
      onChange={({ target: { value } }) => {
        setItemTypeId(value);
      }}
    >
      {(itemTypes?.itemTypes.items || []).map((it) => (
        <option key={it.id} value={it.id}>
          {/* <img
            style={{
              width: '1.5rem',
              height: '1.5rem',
              marginRight: '0.5rem',
            }}
            src={it.image_url || DEFAULT_CONTAINER_STATION_TYPE_ICON}
            alt={it.name}
          /> */}
          {it.name}
        </option>
      ))}
    </Input>
  );
}
